export default "__VITE_ASSET__4329b60c__"